import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import api from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/public/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Course Categories</h1>
      <p className="mt-1 text-slate-500">Discover online programmes by category</p>
      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {cats.map((c) => (
          <Link key={c.id} to={`/courses/${c.slug}`} data-testid={`category-${c.slug}`}
            className="group rounded-xl border border-slate-200 bg-white p-6 transition-all hover:border-blue-300 hover:shadow-md">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-800 transition group-hover:bg-blue-800 group-hover:text-white">
              <GraduationCap className="h-5 w-5" />
            </span>
            <h3 className="mt-3 font-heading font-semibold text-slate-900">{c.name}</h3>
            <p className="mt-1 text-sm text-slate-500">{c.course_count} programmes</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
